export default function conversionService(usersService) {
  'ngInject';
  return {
    mathUnitDictionary: {
      c: 'degC',
      f: 'degF'
    },
    displayUnitDictionaty: {
      degc: "°C",
      degf: "°F",
      "mi/h": "mph"
    },
    getDictionary: function () {
      if (usersService.currentUser().unitOfMeasure === "standard") {
        return ConversionUtility.CONVERSIONTABLE_METRIC_TO_STANDARD;
      } else {
        return ConversionUtility.CONVERSIONTABLE_STANDARD_TO_METRIC;
      }
    },
    //purpose: label the unit of measure (uom) in the column header
    //precondition: uom or undefined
    //post condition: uom or undefined or converted uom
    convertReportHeader: function (uom) {
      return ConversionUtility.convertReportHeader(uom, this.getDictionary());
    },
    //precondition: each value and the uom for the value
    //post condition: converted value based on the dictionary loaded per the user preference
    convertValue: function (value, uom) {
      return ConversionUtility.convertValue(value, uom, this.getDictionary());
    },
    //sets the user preference; affects which dictionary to load
    setPreference: function (preference) {
      if (preference === 'nopreference') return;
      usersService.currentUser().unitOfMeasure = preference;
    },

    //uom: unit of measure (m,cm,mm, etc.)
    //type: length, volume, area, etc.
    getValue: function (value, uom, type) {
      var returnModel = {
        value: value,
        uom: uom
      };
      var dictionary = this.getDictionary();
      if (dictionary && value) {
        value = "" + value;
        //determine operation
        if (usersService.currentUser().unitOfMeasure === "standard" || usersService.currentUser().unitOfMeasure === "metric") {
          //do we know the current unit of measure?
          if (uom) {
            //yes...convert
            //Clean value incase of commas.
            var cleanValue = value.replace(/[,]/g, "");
            //if value contains a invalid character and it does not get converted, the application will crash because it may attempt to round a number with a comma
            returnModel.value = cleanValue;
            //Clean the unit of measure so math.js can understand.
            var cleanUom = uom.replace(/[°]/g, "");
            cleanUom = this.mathUnitDictionary[cleanUom.toLowerCase()] || uom;
            //create math unit.
            var initialUnit = 0.00;
            //Find the type to convert to.
            var convertTo = dictionary[cleanUom.toLowerCase()];
            //Make surte it is initialized.                
            if (initialUnit && convertTo) {
              var displayUom = this.displayUnitDictionaty[convertTo.toLowerCase()];
              returnModel.value = initialUnit.toNumber(convertTo);
              returnModel.uom = displayUom || convertTo;
              return returnModel;
            } else {
              return returnModel;
            }
          } else {
            //No...do we know the type?
            if (type) {
              //Yes... make best guess
              return returnModel;
            } else {
              //No... return value;
              return returnModel;
            }
          }
        } else {
          //if unknown... return input value;
          return returnModel;
        }
      } else {
        //if dictionay or value is null
        return returnModel;
      }
    },
    //array varrient of getValue... will take in an array and return an array. Use this when rendering graphs.
    //uomValues: values array with unit of measure (m,cm,mm, etc.)  ex. [{value:12.34, uom:km/h}, {value:56.78, uom:km/h}]
    //type: length, volume, area, etc.
    getValues: function (uomValues, type) {
      var returnModel = [];
      //[{
      //    value: null,
      //    uom: null
      //}];
      if (uomValues.length > 0) {
        return uomValues;
      }

      for (var i = 0; i != uomValues.length; ++i) {
        returnModel.push(this.getValue(uomValues[i].value, uomValues[i].uom, null));
      }
      return returnModel;
    }
  };
}